import { CookieConsent } from '~/lib/services/content/footer/footer.dtos'

export const useSecuritiHead = (consent: CookieConsent | null) => {
  if (!consent?.dataTenantUuid || !consent?.dataDomainUuidLanding) return

  useHead({
    script: [
      {
        key: 'google-consent-defaults',
        src: `https://cdn-prod.securiti.ai/consent/cookie_banner/${consent.dataTenantUuid}/${consent.dataDomainUuidLanding}/google_consent_defaults.js`,
        type: 'text/javascript',
        tagPriority: 'critical',
      },
      {
        key: 'securiti-auto-blocking',
        src: `https://cdn-prod.securiti.ai/consent/auto_blocking/${consent.dataTenantUuid}/${consent.dataDomainUuidLanding}.js`,
        type: 'text/javascript',
        tagPriority: 'high',
      },
      {
        'key': 'securiti-cookie-consent',
        'id': 'securitiCookieConsent',
        'src': 'https://cdn-prod.securiti.ai/consent/cookie-consent-sdk-loader.js',
        'defer': true,
        'data-tenant-uuid': consent.dataTenantUuid,
        'data-domain-uuid': consent.dataDomainUuidLanding,
        'data-backend-url': 'https://app.securiti.ai',
        'data-skip-css': 'false',
      },
    ],
  })
}
